/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useEffect, useReducer } from 'react'
import { AuthenticationResult } from '@azure/msal-browser'
import { MsalBase } from 'components/azure-provider/msal-base'
import Storage from './storage'

export type AzureContextType = {
  msalInstance: MsalBase | null
  authenticationResult: AuthenticationResult | null
  refreshToken: () => void
  logout: () => void
  login: () => void
  isLoading: boolean
  isAuthenticated: boolean
}
export const AzureContext = createContext<AzureContextType>({
  msalInstance: null,
  authenticationResult: null,
  isLoading: false,
  refreshToken: () => {},
  logout: () => {
    sessionStorage.clear()
    localStorage.clear()
  },
  login: () => {},
  isAuthenticated: false,
})
type Props = {
  children: React.ReactChild
  msalInstance: MsalBase
}

const AUTHENTICATION_RESULT = 'AUTHENTICATION_RESULT'
type StateType = {
  isLoading: boolean
  isAuthenticated: boolean
  authenticationResult: AuthenticationResult | null
}
type ActionType = {
  type: string
  payload?: any
}
const initialState: StateType = {
  isLoading: false,
  isAuthenticated: false,
  authenticationResult: null,
}

function reducer(state: StateType, action: ActionType) {
  switch (action.type) {
    case 'INIT_REDIRECT':
      return { ...state, isLoading: true }
    case 'END_REDIRECT':
      return {
        ...state,
        isLoading: false,
        authenticationResult: action.payload,
        isAuthenticated: !!action.payload,
      }
    case 'INIT_REFRESHTOKEN':
      return {
        ...state,
        isLoading: true,
      }
    case 'END_REFRESHTOKEN':
      return {
        ...state,
        isLoading: false,
        authenticationResult: action.payload,
        isAuthenticated: !!action.payload,
      }
    default:
      throw new Error()
  }
}

export const AzureProvider: React.FC<Props> = (props: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const storage = new Storage(props.msalInstance.options.storage)
  const { children } = props

  const handleRedirect = async () => {
    if (props.msalInstance) {
      dispatch({ type: 'INIT_REDIRECT' })
      const resultStorage = storage.getItem(AUTHENTICATION_RESULT)
        ? JSON.parse(storage.getItem(AUTHENTICATION_RESULT) as string)
        : null
      const result =
        (await props.msalInstance.handleRedirect()) || resultStorage
      dispatch({ type: 'END_REDIRECT', payload: result })
      if (result) {
        storage.setItem(AUTHENTICATION_RESULT, JSON.stringify(result))
      }
    }
  }

  const refreshToken = async () => {
    if (!props.msalInstance) {
      console.log('msalInstance no está disponible')
      return
    }

    if (!state.authenticationResult?.account) {
      console.log('Usuario no autenticado. Redirigiendo al inicio de sesión...')
      await props.msalInstance.login()
      return
    }

    dispatch({ type: 'INIT_REFRESHTOKEN' })
    try {
      console.log('Intentando refrescar token...')
      const result = await props.msalInstance.refreshToken(
        state.authenticationResult.account
      )
      dispatch({ type: 'END_REFRESHTOKEN', payload: result })
      storage.setItem(AUTHENTICATION_RESULT, JSON.stringify(result))
    } catch (error) {
      console.error('Error refrescando token:', error)
      dispatch({ type: 'END_REFRESHTOKEN', payload: null })
      await props.msalInstance.login()
    }
  }

  // const refreshToken2 = async () => {
  //   if (props.msalInstance) {
  //     if (state.authenticationResult?.account) {
  //       dispatch({ type: 'INIT_REFRESHTOKEN' })
  //       const result = await props.msalInstance.refreshToken(
  //         state.authenticationResult.account
  //       )
  //       dispatch({ type: 'END_REFRESHTOKEN', payload: result })
  //     }
  //   }
  // }
  const logout = () => {
    props.msalInstance?.logout()
    storage.removeItem(AUTHENTICATION_RESULT)
    sessionStorage.clear()
    localStorage.clear()
  }
  const login = () => props.msalInstance?.login()

  useEffect(() => {
    if (props.msalInstance) handleRedirect()
  }, [props.msalInstance])

  return (
    <AzureContext.Provider
      value={{
        msalInstance: props.msalInstance,
        refreshToken,
        ...state,
        logout,
        login,
      }}
    >
      {children}
    </AzureContext.Provider>
  )
}
